module.exports = __webpack_public_path__ + "static/img/platinum 2.403eae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/platinum 2.png
// module id = YCQ+
// module chunks = 35